<template>
  <div class="sso-auth-root"></div>
</template>

<script>
import cache from "utils/cache";
import {verifyToken} from "api/sso";
import { markSsoMode } from "utils/sso";

let globalSsoListenersBound = false;

export default {
  name: 'SsoAuthPage',
  data() {
    return {};
  },
  mounted() {
    this.bootstrapSso();
  },
  activated() {
    this.bootstrapSso();
  },
  watch: {
    '$route'(to) {
      if (to.path === '/auth') {
        this.bootstrapSso();
      }
    }
  },
  methods: {
    bootstrapSso() {
      if (typeof a2 === 'undefined') {
        console.error('SSO SDK 未加载');
        return;
      }
      if (cache.get('device-Token')) {
        return;
      }
      const urlToken = this.$route.query.token;
      // 如果有 URL token，先验证，不要初始化 SSO SDK（避免 autoLogin 触发弹窗）
      if (urlToken) {
        this.verifyToken({ accessToken: urlToken });
        return;
      }
      // 没有 URL token 时，才走 SSO SDK 的自动登录流程
      this.initSsoSdk();
      this.$nextTick(() => {
        if (cache.get('device-Token')) {
          return;
        }
        // 此处不会再走到，因为 urlToken 已经在上面处理了
        setTimeout(() => this.openSsoLogin(), 300);
      });
    },
    bindEventListeners() {
      if (globalSsoListenersBound) {
        return;
      }
      globalSsoListenersBound = true;
      console.log("进入认证");
      a2.on('ready', (result) => {
        console.log("用户通过认证0", result);
        this.verifyToken(result);
      });
      a2.on('auth', () => {
        console.log("用户需要认证1");
        const urlToken = this.$route.query.token;
        if (urlToken) {
          this.verifyToken({ accessToken: urlToken });
        } else {
          this.openSsoLogin();
        }
      });
      a2.on('login-page', (result) => {
        console.log("用户需要认证2");
        if (result.code === 0) {
          this.verifyToken(result.data);
          console.log("login-page", result);
        }
      });
    },
    initSsoSdk() {
      if (typeof a2 === 'undefined') {
        return;
      }
      // 避免重复初始化
      if (this._ssoInited) {
        return;
      }
      this._ssoInited = true;
      a2.init({
        appId: 'apf9de58dddd6549d9acf72108f6f82089',
        patterns: [/as\.zaiyaa\.com/],
        useTestServer: false,
        autoLogin: true
      });
      this.bindEventListeners();
    },
    openSsoLogin() {
      // 确保 SDK 已初始化
      this.initSsoSdk();
      if (typeof a2 === 'undefined' || typeof a2.openLoginPage !== 'function') {
        return;
      }
      a2.openLoginPage({
        style: 2,
        defaultMethod: 'normal',
        zIndex: 998
      });
    },
    normalizePath(path) {
      const value = String(path || '').trim();
      if (!value) {
        return '/rmsprofile';
      }
      const normalized = value.startsWith('/') ? value : `/${value}`;
      return normalized.toLowerCase();
    },
    resolveSsoCredentials(tokenData) {
      if (!tokenData || typeof tokenData !== 'object') {
        return { accessToken: '', username: '' };
      }
      const accessToken = tokenData.accessToken
        || tokenData.token
        || tokenData.access_token
        || '';
      let username = tokenData.username
        || tokenData.userName
        || tokenData.name
        || '';
      if (tokenData.user && typeof tokenData.user === 'object') {
        username = username
          || tokenData.user.username
          || tokenData.user.userName
          || tokenData.user.name
          || '';
      }
      return { accessToken, username };
    },
    persistLoginState(res) {
      cache.set("device-nickname", res.data.nickname);
      cache.set("device-id", res.data.id);
      const token = res.data.token || res.data.name || '';
      cache.set('device-Token', token);
      cache.set('device-name', res.data.name);
      cache.set("device-menus", res.data.menus || []);
      cache.set("device-authorizes", res.data.authorizes || []);
      markSsoMode();
    },
    async verifyToken(tokenData) {
      try {
        const { accessToken, username } = this.resolveSsoCredentials(tokenData);
        console.log('sso credentials', { accessToken, username, raw: tokenData });
        verifyToken(accessToken, username)
            .then(res => {
              console.log(res);
              console.log('认证成功', res.data);
              if (res.code == 1003 || res.code == 999){
                this.$message.error(res.msg);
                this.openSsoLogin();
              } else if(res.code == 0){
                this.persistLoginState(res);
                const menus = res.data.menus || [];
                const target = menus.length > 0
                  ? this.normalizePath(menus[0].url)
                  : '/rmsprofile';
                this.$router.replace({ path: target });
              } else {
                this.$message.warn('登录失败！');
                this.openSsoLogin();
              }
            })
            .catch(err => {
              console.log(err)
              if (err.code != 1003 && err.code != 999){
                this.$message.error('登录失败！！');
              } else {
                this.$message.error(err.msg);
              }
              this.openSsoLogin();
            })
      } catch (error) {
        console.error('令牌验证失败', error);
        this.openSsoLogin();
      }
    }
  }
};
</script>

<style scoped>
.sso-auth-root {
  min-height: 100vh;
}
</style>
